import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environment';
import { ApiResponse, UserData } from '../models/user-data-model';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private readonly BASE_ETF_API: string = environment.baseEtfApi;

  constructor(private readonly http: HttpClient) {}

  public saveUser(userData: UserData): Observable<ApiResponse> {
    const payload = {
      ...userData,
      status: 'New Request',
      isFullAccess: false
    };

    return this.http.post<ApiResponse>(`${this.BASE_ETF_API}/user/save`, payload);
  }
}
